
<template>
	<div style="width: 100%; display: flex; height: 100%">
		<v-navigation-drawer
			floating
			v-if="units"
			v-model="drawer"
			class="light-blue lighten-5 elevation-5"
			style="position: fixed;"
		>
			<v-list dense class="pt-0">
				<v-list-tile v-for="(item, index) in units" :key="item.unitId" @click>
					<v-list-tile-avatar>
						<status-indicator
							positive
							pulse
							v-if="item.inRent"
							style="transform: translate(20px,5px); position: absolute"
							class="left"
						></status-indicator>
						<img
							v-bind:src="item.img_small"
							v-if="!item.avatar"
							@error="setPlaceHolder(item)"
						/>
						<v-icon v-if="item.avatar">directions_car</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content
						@click="
							toggleInfoWindow(markers[index], index, $event);
							drawer = false;
						"
					>
						<v-list-tile-title
							>{{ item.name }} {{ item.license }} ({{
								item.pos.s
							}}
							km/u)</v-list-tile-title
						>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-btn color="info" flat @click="drawer = false">Sluiten</v-btn>
		</v-navigation-drawer>

		<gmap-map
			v-if="true"
			:center="mapCenter"
			:zoom="7"
			map-type-id="terrain"
			:options="{
				gestureHandling: 'greedy',
				styles: !themeLight ? styles : []
			}"
			style="width: 100%; flex: 1;"
			@click="getPos"
		>
			<gmap-info-window
				:options="infoOptions"
				:position="infoWindowPos"
				:opened="infoWinOpen"
				@closeclick="infoWinOpen = false"
				:content="infoContent"
			>
				<v-icon style="font-size: 16px">directions_car</v-icon>
				{{ selectedReservation.title }} {{ selectedReservation.action }}
				<br />
				<span v-if="selectedReservation.inRent">
					{{ selectedReservation.startDate }}
					<br />
					{{ selectedReservation.endDate }}
					<br />
					{{ selectedReservation.user }}
				</span>
			</gmap-info-window>

			<gmap-marker
				:key="index"
				v-for="(m, index) in markers"
				:position="m.position"
				:clickable="true"
				:label="m.label"
				class="labelClass"
				@click="toggleInfoWindow(m, index, $event)"
			></gmap-marker>
		</gmap-map>
		<v-btn
			color="blue"
			dark
			absolute
			bottom
			left
			fab
			style="bottom: 20px"
			@click="drawer = !drawer"
		>
			<v-icon>directions_car</v-icon>
		</v-btn>
	</div>
</template>
<script>
import * as utils from '@/utils/utils';
import { _ } from 'vue-underscore';
import { StatusIndicator } from 'vue-status-indicator';
export default {
	name: 'UnitsMap',
	components: { StatusIndicator },
	props: ['showMap'],
	data() {
		return {
			showMaps: false,
			markers: [],
			infoWinOpen: false,
			drawer: false,
			utils: utils,
			units: [],
			itv: null,
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoContent: '',
			currentMidx: 0,
			styles: [
				{ elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
				{ elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
				{ elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
				{
					featureType: 'administrative.locality',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#d59563' }]
				},
				{
					featureType: 'poi',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#d59563' }]
				},
				{
					featureType: 'poi.park',
					elementType: 'geometry',
					stylers: [{ color: '#263c3f' }]
				},
				{
					featureType: 'poi.park',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#6b9a76' }]
				},
				{
					featureType: 'road',
					elementType: 'geometry',
					stylers: [{ color: '#38414e' }]
				},
				{
					featureType: 'road',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#212a37' }]
				},
				{
					featureType: 'road',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#9ca5b3' }]
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry',
					stylers: [{ color: '#746855' }]
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#1f2835' }]
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#f3d19c' }]
				},
				{
					featureType: 'transit',
					elementType: 'geometry',
					stylers: [{ color: '#2f3948' }]
				},
				{
					featureType: 'transit.station',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#d59563' }]
				},
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [{ color: '#17263c' }]
				},
				{
					featureType: 'water',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#515c6d' }]
				},
				{
					featureType: 'water',
					elementType: 'labels.text.stroke',
					stylers: [{ color: '#17263c' }]
				}
			],
			items: [
				{ title: 'Home', icon: 'dashboard' },
				{ title: 'About', icon: 'question_answer' }
			],
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			themeLight: true,
			selectedReservation: {},
			mapCenter: { lat: 53.177388, lng: 5.417791 }
		};
	},
	created() {
		if (this.showMap) {
			this.setMarkers();
		}
	},
	methods: {
		closeMap() {
			window.emitter.$emit('closeMap');
		},
		setMarkers() {
			var self = this;
			//if (!self.units.length && !self.markers.length) {
			utils
				.getData(basePath + 'api/rentunits/getUnits/0')
				.then(function(response) {
					if (!self.units.length && !self.markers.length) {
						self.units = response.data;
						for (var i = 0; i < self.units.length; i++) {
							var unit = self.units[i];
							if (unit.pos) {
								var unitPos = { lat: unit.pos.y, lng: unit.pos.x };
								var text =
									unit.name + ' ' + unit.license + '(' + unit.pos.s + ' km/u)';
								var content = text;
								if (unit.inRent) {
									var rentData = unit.rentData[0];
									content +=
										'<br/>' +
										rentData.startDate +
										' t/m ' +
										rentData.endDate +
										'. door: ' +
										rentData.lastname;
								}

								self.markers.push({
									position: unitPos,
									title: text,
									rentData: rentData,
									id: unit.unitId,
									speed: parseInt(unit.pos.s),
									inRent: unit.inRent,
									class: 'labelClass'
								});
							}
						}
					} else {
						self.updateMarkers(response.data);
					}
				});
			//}
		},
		updateMarkers: function(updatedUnits) {
			var self = this;
			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.pos) {
					var unitPos = { lat: unit.pos.y, lng: unit.pos.x };
					var marker = _.findWhere(self.markers, { id: unit.unitId });
					marker.position = unitPos;
					marker.speed = String(unit.pos.s);
				}
			}
		},
		updateMarkersFromEvents: function(updatedUnits) {
			var self = this;
			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.d.pos) {
					var unitPos = { lat: unit.d.pos.y, lng: unit.d.pos.x };
					var marker = _.findWhere(self.markers, { id: String(unit.i) });
					if (marker) {
						marker.position = unitPos;
						marker.speed = String(unit.d.pos.s);
					}
				}
			}
		},
		toggleInfoWindow: function(marker, idx, event) {
			this.infoWindowPos = marker.position;
			this.mapCenter = marker.position;
			this.infoContent = marker.content;
			this.selectedReservation.title = marker.title;
			if (marker.inRent) {
				this.selectedReservation.startDate = marker.rentData.startDate;
				this.selectedReservation.endDate = marker.rentData.endDate;
				this.selectedReservation.inRent = marker.inRent;
				this.selectedReservation.user =
					marker.rentData.firstname + ' ' + marker.rentData.lastname;
				this.selectedReservation.action = '';
			} else {
				this.selectedReservation.action =
					marker.speed == 0 ? ' - Geparkeerd' : '';
			}

			//check if its the same marker that was selected if yes toggle
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			}
			//if different marker set infowindow to open and reset current marker index
			else {
				this.infoWinOpen = true;
				this.currentMidx = idx;
			}

			return true;
		},
		getPos(val) {
			//console.log(val.latLng.lat())
		},
		getEvents() {
			this.setMarkers();
		},
		setPlaceHolder(item) {
			item.avatar = true;
		}
	},
	watch: {
		showMap(newValue) {
			var self = this;
			this.themeLight =
				localStorage.getItem('theme') === 'light' ||
				!localStorage.getItem('theme')
					? true
					: false;
			if (newValue) {
				var self = this;
				setTimeout(function() {
					self.showMaps = true;
					self.setMarkers();
					window.emitter.$on('newEvents', data => {
						self.updateMarkersFromEvents(data);
					});
				}, 500);

				/*   self.itv = setInterval(function() {
          self.setMarkers();
        }, 20000); */
			} else {
				if (self.itv) {
					clearInterval(self.itv);
				}
			}
		}
	}
};
</script>
<style>
.navigation-drawer--floating {
	position: absolute;
	top: 140px !important;
}
.btn--bottom {
	bottom: 30px !important;
}
.labelClass {
	color: rgb(167, 0, 0);
}
.vue-map {
	color: #333;
}

.vue-map i.v-icon {
	color: #333 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Units/UnitsMap.vue